import React from 'react'
import { getCssText } from '@grupoboticario/flora'

/**
 * @component
 * @name FloraCssBaseline
 * @description
 * Usage with SSR (Server Side Rendering)
 * Put on _document.tsx file (Next.js)
 * @tutorial https://flora.gb.tech/docs/components/core/flora-provider
 */
export const FloraCssBaseline = () => (
  <>
    <style id="stitches" dangerouslySetInnerHTML={{ __html: getCssText() }} />
  </>
)
